import { render, staticRenderFns } from "./BrightcoveVideo.vue?vue&type=template&id=54a70475&scoped=true"
import script from "./BrightcoveVideo.vue?vue&type=script&lang=ts"
export * from "./BrightcoveVideo.vue?vue&type=script&lang=ts"
import style0 from "./BrightcoveVideo.vue?vue&type=style&index=0&id=54a70475&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a70475",
  null
  
)

export default component.exports